const actions = {
    PRICE_LEVEL_CREATE_REQUEST: 'PRICE_LEVEL_CREATE_REQUEST',
    PRICE_LEVEL_CREATE_SUCCESS: 'PRICE_LEVEL_CREATE_SUCCESS',
    PRICE_LEVEL_CREATE_ERROR: 'PRICE_LEVEL_CREATE_ERROR',

    // PRICE_LEVEL_IMPORT_REQUEST: 'PRICE_LEVEL_IMPORT_REQUEST',
    // PRICE_LEVEL_IMPORT_SUCCESS: 'PRICE_LEVEL_IMPORT_SUCCESS',
    // PRICE_LEVEL_IMPORT_ERROR: 'PRICE_LEVEL_IMPORT_ERROR',

    PRICE_LEVEL_READ_REQUEST: 'PRICE_LEVEL_READ_REQUEST',
    PRICE_LEVEL_READ_SUCCESS: 'PRICE_LEVEL_READ_SUCCESS',
    PRICE_LEVEL_READ_ERROR: 'PRICE_LEVEL_READ_ERROR',

    PRICE_LEVEL_READ_ALL_REQUEST: 'PRICE_LEVEL_READ_ALL_REQUEST',
    PRICE_LEVEL_READ_ALL_SUCCESS: 'PRICE_LEVEL_READ_ALL_SUCCESS',
    PRICE_LEVEL_READ_ALL_ERROR: 'PRICE_LEVEL_READ_ALL_ERROR',

    PRICE_LEVEL_UPDATE_REQUEST: 'PRICE_LEVEL_UPDATE_REQUEST',
    PRICE_LEVEL_UPDATE_SUCCESS: 'PRICE_LEVEL_UPDATE_SUCCESS',
    PRICE_LEVEL_UPDATE_ERROR: 'PRICE_LEVEL_UPDATE_ERROR',

    PRICE_LEVEL_ARCHIVE_REQUEST: 'PRICE_LEVEL_ARCHIVE_REQUEST',
    PRICE_LEVEL_ARCHIVE_SUCCESS: 'PRICE_LEVEL_ARCHIVE_SUCCESS',
    PRICE_LEVEL_ARCHIVE_ERROR: 'PRICE_LEVEL_ARCHIVE_ERROR',

    PRICE_LEVEL_DELETE_REQUEST: 'PRICE_LEVEL_DELETE_REQUEST',
    PRICE_LEVEL_DELETE_SUCCESS: 'PRICE_LEVEL_DELETE_SUCCESS',
    PRICE_LEVEL_DELETE_ERROR: 'PRICE_LEVEL_DELETE_ERROR',

    PRICE_LEVEL_RESET_STATE: 'PRICE_LEVEL_RESET_STATE',
    PRICE_LEVEL_CHANGE: 'PRICE_LEVEL_CHANGE',
    PRICE_LEVEL_TOGGLE_DRAWER: 'PRICE_LEVEL_TOGGLE_DRAWER',

    createPriceLevel: request => ({
        type: actions.PRICE_LEVEL_CREATE_REQUEST,
        request,
    }),
    readPriceLevel: id => ({
        type: actions.PRICE_LEVEL_READ_REQUEST,
        id,
    }),
    readAllPriceLevel: request => ({
        type: actions.PRICE_LEVEL_READ_ALL_REQUEST,
        request,
    }),
    updatePriceLevel: (id, request) => ({
        type: actions.PRICE_LEVEL_UPDATE_REQUEST,
        id,
        request,
    }),
    archivePriceLevel: (id, request) => ({
        type: actions.PRICE_LEVEL_ARCHIVE_REQUEST,
        id,
        request,
    }),
    deletePriceLevel: id => ({
        type: actions.PRICE_LEVEL_DELETE_REQUEST,
        id,
    }),
    resetPriceLevel: id => ({
        type: actions.PRICE_LEVEL_RESET_STATE,
        id,
    }),

    changePriceLevel: (request, reset = false) => ({
        type: actions.PRICE_LEVEL_CHANGE,
        request,
        reset,
    }),

    togglePriceLevelDrawer: (visible, mode) => ({
        type: actions.PRICE_LEVEL_TOGGLE_DRAWER,
        visible,
        mode, // 'create', 'update'
    }),
};
export default actions;
